import { Stack } from '@mui/material';

import ShortlistSummaryCard from '@/north-star/care/shortlists/ShortlistSummaryCard';
import { type PublishedShortlist } from '@/north-star/care/shortlists/fixtures';

// The list of published shortlist cards on the care search page: one
// ShortlistSummaryCard per shortlist.
const ShortlistList = ({
  shortlists,
  onOpen,
}: {
  shortlists: PublishedShortlist[];
  onOpen: (shortlist: PublishedShortlist) => void;
}) => (
  <Stack spacing={2}>
    {shortlists.map((s) => (
      <ShortlistSummaryCard key={s.id} shortlist={s} onOpen={onOpen} />
    ))}
  </Stack>
);

export default ShortlistList;
